export default {
  methods: {
    slide(dir, slide) {
      this.transitionName = slide;

      const length = this.data.length;

      if (this.windowSizeLessThan850) {
        this.first = (this.first + (dir % length) + length) % length;
      } else {
        if (slide === "slide-next" || slide === "slide-next-slow") {
          this.first += 2;
          this.first %= length;

          this.second = (this.first + 1) % length;
        } else {
          if (this.first === 0) {
            this.first = length - 2;
            this.second = length - 1;
          } else if (this.first === 1) {
            this.first = length - 1;
            this.second = 0;
          } else {
            this.first -= 2;
            this.second = this.first + 1;
          }
        }
      }
    },
  },
};
